'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'paintbrush-fine';
var width = 576;
var height = 512;
var aliases = ["paint-brush-alt","paint-brush-fine","paintbrush-alt"];
var unicode = 'f5a9';
var svgPathData = 'M557.3 18.7c25 25 25 65.5 0 90.5L325 341.5c-16.2-41.3-49.2-74.3-90.5-90.5L466.7 18.7c25-25 65.5-25 90.5 0zM288 400c0 61.9-50.1 112-112 112L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l4.8 0c17.6 0 29.6-18.9 27.8-36.4-.4-3.8-.6-7.7-.6-11.6 0-61.9 50.1-112 112-112s112 50.1 112 112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPaintbrushFine = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;